import React from 'react';
import {ConnectedRouter} from 'connected-react-router';
import {ToastContainer} from "react-toastify";
import {History} from 'history';
import Routes from './routes';

interface AppProps {
    history: History
}

const App: React.FC<AppProps> = ({history}) => {
    return (
        // @ts-ignore
        <ConnectedRouter history={history}>
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Routes/>
        </ConnectedRouter>
    )
}

export default App